
















import VueOptions from '@utils/VueOptions'
import AdvanceShow from '@modules/ui/Event/sections/SponsorAdvance/AdvanceShow'

settings = 
  name: 'Advance'
  resources:
    advance:
      resourceName: "advance"
      slug: "offers/:offerId/advance"
  vue:
    components: { AdvanceShow }
    props: ['offerId']

export default VueOptions.vue settings
